import { inject, Injectable } from '@angular/core';
import { HttpCoreService } from '@dataclouder/ngx-core';

const CreateCheckoutSession = 'api/payments/stripe/create-checkout-session';
const PaymentApi = {
  ApplySusbcription: 'api/payments/apply-subscription',
};

@Injectable({
  providedIn: 'root',
})
export class NGXStripeService {
  private httpService = inject(HttpCoreService);

  constructor() {}

  async createSessionPremiumMonths(months: number) {
    const response = await this.httpService.post(CreateCheckoutSession, { months: months });

    if (response.sessionUrl) {
      window.location.href = response['sessionUrl'];
    } else {
      console.error('POST no puede contactar el sistema de pagos error', response);
    }
  }

  async updateUserSubscriptionIfPaid(sessionId: string) {
    const response = await this.httpService.get(`${PaymentApi.ApplySusbcription}/${sessionId}`);
    return response;
  }
}
